import { ComponentIds, HierarchyUtils, ValidationResultFail } from '@inter-ikea-core/core';
import { PartKey, PlannerValidation, ProductType } from '@inter-ikea-storageone/range';
export class RestrictDoorsOnCornerBaseFrameValidationRule extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'RestrictDoorsOnCornerBaseFrameValidationRule');
        this.coreApi = coreApi;
    }
    validateCurrentState(entity) {
        return this.validate(entity);
    }
    validateSnap(snapActionCandidate) {
        return this.validate(snapActionCandidate.guestRoot, snapActionCandidate);
    }
    validate(entity, snapActionCandidate) {
        const doorEntity = entity;
        if (!doorEntity.hasComponent(ComponentIds.DOOR_COMPONENT_ID)) {
            return this.validationOK();
        }
        const baseFrame = snapActionCandidate?.host;
        if (baseFrame?.getComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID)
            ?.partKey !== PartKey.CORNER_SOLUTION_NORMAL_FRAME) {
            return this.validationOK();
        }
        const addonFrame = HierarchyUtils.descendants(baseFrame).find(it => this.coreApi.entities.isProductType(it, ProductType.PAX_ADD_ON_CORNER_FRAME));
        if (!addonFrame) {
            return this.validationOK();
        }
        const doorWidth = this.coreApi.entities.getEntityComSize(doorEntity)?.width;
        const baseFrameWidth = this.coreApi.entities.getEntityComSize(baseFrame)?.width;
        const addonFrameDepth = this.coreApi.entities.getEntityComSize(addonFrame)?.depth;
        if (this.doorBaseFrameAndFrameHasCorrectSizes(doorWidth, baseFrameWidth, addonFrameDepth)) {
            return this.validationOK();
        }
        else {
            return new ValidationResultFail(`Door ${doorWidth} wide not allowed in ${baseFrameWidth} wide corner base frame with ${addonFrameDepth} deep addon frame`, '', this);
        }
    }
    doorBaseFrameAndFrameHasCorrectSizes(doorWidth, baseFrameWidth, addonFrameDepth) {
        return ((addonFrameDepth === 580.0 && baseFrameWidth === 1000.0 && doorWidth === 500.0) ||
            (addonFrameDepth === 580.0 && baseFrameWidth === 750.0 && doorWidth === 250.0) ||
            (addonFrameDepth === 350.0 && baseFrameWidth === 750.0 && doorWidth === 500.0) ||
            (addonFrameDepth === 350.0 && baseFrameWidth === 500.0 && doorWidth === 250.0));
    }
}
//# sourceMappingURL=RestrictDoorsOnCornerBaseFrameValidationRule.js.map